import(/* webpackMode: "eager" */ "/vercel/path0/src/app/milestones/page.tsx");
